import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import PeriodsList from './PeriodsList/PeriodsList';
import PeriodCreate from './PeriodCreate/PeriodCreate';
import PeriodEdit from './PeriodEdit/PeriodEdit';
import PeriodDelete from './PeriodDelete/PeriodDelete';

const Periods = ({ match }) => {
    return (
        <div className="Periods">
            <ContainerWrapper container="periods">
                <Route exact path={ match.path } component={PeriodsList} />
                <Route exact path={ `${ match.url }/new` } component={PeriodCreate} />
                <Route exact path={ `${ match.url }/edit/:periodId` } component={PeriodEdit} />
                <Route exact path={ `${ match.url }/delete/:periodId` } component={PeriodDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Periods;
